import styled from '@emotion/styled';
import { ntaBodyBoldCss, ntaBodyCss, ntaListMarkerCss } from '../typography';
import {
  NTA_GENERAL_INSTRUCTIONS,
  NTA_PALETTE_LEGEND
} from './ntaInstructionsContent';
import NtaPaletteLegendIcon from './NtaPaletteLegendIcon';

const PaletteLegend = styled.div`
  margin-top: 0;
`;

const LegendIntro = styled.span`
  ${ntaBodyCss}
`;

const PaletteRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 24px 0 48px;
`;

const PaletteRowSpaced = styled(PaletteRow)`
  padding-top: 12px;
`;

const PaletteRowLast = styled(PaletteRowSpaced)`
  padding-bottom: 8px;
`;

const PaletteSubNumber = styled.span`
  flex-shrink: 0;
  width: 24px;
  text-align: right;
  ${ntaListMarkerCss}
`;

const PaletteText = styled.p`
  margin: 0;
  flex: 1;
  ${ntaBodyCss}

  strong {
    ${ntaBodyBoldCss}
  }
`;

const renderPaletteText = (item) => {
  if (item.textBold) {
    return (
      <>
        {item.textBeforeBold}
        <strong>{item.textBold}</strong>
        {item.textAfterBold}
      </>
    );
  }
  return item.text;
};

const getPaletteRowComponent = (index, total) => {
  if (index === 0) return PaletteRow;
  if (index === total - 1) return PaletteRowLast;
  return PaletteRowSpaced;
};

const NtaPaletteLegend = () => (
  <PaletteLegend>
    <LegendIntro>{NTA_GENERAL_INSTRUCTIONS[2]}</LegendIntro>
    {NTA_PALETTE_LEGEND.map((item, index) => {
      const Row = getPaletteRowComponent(index, NTA_PALETTE_LEGEND.length);

      return (
        <Row key={item.key}>
          <PaletteSubNumber>{index + 1}.</PaletteSubNumber>
          <NtaPaletteLegendIcon icon={item.icon} />
          <PaletteText>{renderPaletteText(item)}</PaletteText>
        </Row>
      );
    })}
  </PaletteLegend>
);

export default NtaPaletteLegend;
